import axios from 'axios';
import { BASE_URL } from '../../../../../utils';
export const API = axios.create({
  baseURL: `${BASE_URL}`,
});

// ===== CHECKLISTS APIS =====
export const getChecklists = ({ page = 1, limit = 20, q = '' } = {}) =>
  API.get('/housekeeping-checklists', { params: { page, limit, q } });


export const getTaskHistory = (params = {}) =>
  API.get('/housekeeping/tasks/history', { params });
export const getTaskHistoryById = (taskId, params = {}) =>
  API.get(`/housekeeping/tasks/${taskId}/history`, { params });
export const createChecklist = (payload) => API.post('/housekeeping-checklists', payload);
export const updateChecklist = (id, payload) => API.put(`/housekeeping-checklists/${id}`, payload);
export const deleteChecklist = (id) => API.delete(`/housekeeping-checklists/${id}`);

// ===== STAFF APIS =====
export const getHousekeepingStaff = () => API.get('/user');

// ===== HOUSEKEEPING/tasks TASK APIS - CORRECTED =====
export const listTasks = (params) => API.get('/housekeeping/tasks', { params });
export const createTask = (data) => API.post('/housekeeping/tasks', data);
export const getTaskById = (id) => API.get(`/housekeeping/tasks/${id}`);
export const updateTask = (id, data) => API.put(`/housekeeping/tasks/${id}`, data);
export const deleteTask = (id) => API.delete(`/housekeeping/tasks/${id}`);
export const updateTaskStatus = (id, data) => API.patch(`/housekeeping/tasks/${id}/status`, data);
export const addPhotos = (id, formData) => API.post(`/housekeeping/tasks/${id}/photos`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const getAuditsByTask = (id, params) => API.get(`/housekeeping/tasks/${id}/audits`, { params });
export const getAuditById = (auditId) => {
  return API.get(`/housekeeping/audits/${auditId}`);
};
export const getTaskStatistics = (params) => API.get('/housekeeping/tasks/analytics/overview', { params });
export const getOverdueTasks = (params) => API.get('/housekeeping/tasks/analytics/overdue', { params });
export const bulkUpdateTasks = (data) => API.patch('/housekeeping/tasks/bulk/status', data);

// ===== HOUSEKEEPING/tasks RESOURCE APIS =====
export const getAvailableRooms = (params) => API.get('/housekeeping/tasks/resources/rooms', { params });
export const getWardsAndFloors = () => API.get('/housekeeping/tasks/resources/locations');
// Add this to your API service file
export const getRoomWithBeds = (roomId) => API.get(`/housekeeping/tasks/room/${roomId}/beds`);

// ===== BACKWARD COMPATIBILITY - OLD TASK ENDPOINTS =====
// Keep these for components that still use the old endpoints
export const getTasks = (params) => API.get('/housekeeping/tasks', { params });
export const addTaskPhotos = (id, formData) => API.post(`/housekeeping/tasks/${id}/photos`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// ===== AUDITS APIS =====
export const createAudit = (data) => API.post('/housekeeping/audits', data);
export const listAudits = () => API.get('/housekeeping/audits');

// ===== UPLOADS APIS =====
export const uploadHousekeepingImages = (formData) =>
  API.post('/housekeeping/tasks/uploads/housekeeping-images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const uploadLinenImages = (formData) => {
  return API.post('/linen/receive/uploads/linen-images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};


export const uploadDispatchImages = (formData) => {
  return API.post('/linen/dispatches/uploads/dispatch-images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};


// ===== DASHBOARD APIS =====
export const getHousekeepingDashboard = () => API.get('/housekeeping/dashboard');


// ===== LINEN MANAGEMENT APIS =====

// Vendors - Enhanced
export const getLinenVendors = (params) => API.get("/linen/vendors", { params });
export const getLinenVendor = (id) => API.get(`/linen/vendors/${id}`);
export const createLinenVendor = (data) => API.post("/linen/vendors", data);
export const updateLinenVendor = (id, data) => API.put(`/linen/vendors/${id}`, data);
export const deleteLinenVendor = (id) => API.delete(`/linen/vendors/${id}`);
export const updateVendorStatus = (id, data) => API.patch(`/linen/vendors/${id}/status`, data);
export const getServiceTypes = () => API.get('/linen/vendors/service-types');
export const getActiveVendors = () => API.get('/linen/vendors/active');
export const bulkUpdateVendors = (data) => API.patch('/linen/vendors/bulk', data);
export const exportVendors = (params) => API.get('/linen/vendors/export', {
  params,
  responseType: 'blob'
});
export const importVendors = (formData) => API.post('/linen/vendors/import', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const getVendorStats = () => API.get('/linen/vendors/stats');

// Items Master - Enhanced
export const getLinenItems = (params) => API.get("/linen/items", { params });
export const getLinenItem = (id) => API.get(`/linen/items/${id}`);
export const createLinenItem = (data) => API.post("/linen/items", data);
export const updateLinenItem = (id, data) => API.put(`/linen/items/${id}`, data);
export const deleteLinenItem = (id) => API.delete(`/linen/items/${id}`);
export const updateLinenItemStatus = (id, data) => API.patch(`/linen/items/${id}/status`, data);
export const getCategories = () => API.get('/linen/items/categories');
export const getLowStockItems = (params = {}) => API.get('/linen/items/low-stock', { params });
export const bulkUpdateLinenItems = (data) => API.patch('/linen/items/bulk', data);
export const exportLinenItems = (params) => API.get('/linen/items/export', {
  params,
  responseType: 'blob'
});
export const importLinenItems = (formData) => API.post('/linen/items/import', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const getLinenItemStats = () => API.get('/linen/dashboard/item-stats');


// ===== LINEN DISPATCH APIS =====
export const getLinenDispatches = (params) => API.get("/linen/dispatches", { params });
export const getLinenDispatch = (id) => API.get(`/linen/dispatches/${id}`);
export const createLinenDispatch = (data) => API.post("/linen/dispatches", data);
export const updateLinenDispatch = (id, data) => API.put(`/linen/dispatches/${id}`, data);
export const deleteLinenDispatch = (id) => API.delete(`/linen/dispatches/${id}`);
export const getDispatchesByVendor = (vendorId, params = {}) => 
  API.get(`/linen/dispatches/vendor/${vendorId}`, { params });
export const getDispatchDetails = (dispatchId) => API.get(`/linen/dispatches/${dispatchId}`);

// Receive
export const receiveLinen = (data) => API.post("/linen/receive", data);
export const getReceiveHistory = (params = {}) => API.get("/linen/receive", { params });
export const getReceiveById = (id) => API.get(`/linen/receive/${id}`);

// Transactions
export const getAllLinenTransactions = () => API.get("/linen/transactions");
export const getLinenTransactions = (params = {}) => API.get("/linen/transactions", { params });
export const getLinenDashboard = () => API.get("/linen/dashboard");

// Issue/Return
export const createLinenIssue = (data) => API.post("/linen/issue", data);
export const getLinenIssues = (params) => API.get("/linen/issue", { params });
export const createLinenReturn = (data) => API.post("/linen/return", data);
export const getLinenReturns = (params) => API.get("/linen/return", { params });
export const getLinenIssueStats = (params = {}) => API.get("/linen/issue/stats", { params });

// Reports
export const getDashboardStats = () => API.get("/linen/dashboard");
export const getLinenDailyReport = (date) => API.get("/linen/reports/daily", { params: { date } });
export const getLinenWardConsumption = (from, to) => API.get("/linen/reports/ward-consumption", { params: { from, to } });
export const getLinenDispatchReceiveReport = (from, to) => API.get("/linen/reports/dispatch-receive", { params: { from, to } });